import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CancelButton } from 'skrit-web-framework/components/buttons';
import Drawer from 'skrit-web-framework/components/Drawer';
import translate from 'skrit-web-framework/translator';
import { getBreakpoints } from 'skrit-web-framework/utils';

import ErrorBoundary from 'skrit-web-framework/components/ErrorBoundary';
import { FALLBACKS } from 'skrit-web-framework/constantes';
import Articulos from '../motoscat/Articulos';
import MarcasMotos from '../motoscat/MarcasMotos';
import { MOTOSCAT_VIEW } from '../utils/ConstantesComunes';

const mapStateToProps = (state, props) => {
    return {
        ...state.motoscat,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        iniMotoscat() {
            dispatch({ type: 'INI_MOTOSCAT' });
        },
        closeMotoscat: () => {
            dispatch({ type: 'CLOSE_MOTOSCAT' });
        },
    };
};

class Motoscat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewHistory: [],
            isGoingBack: false,
            openCesta: false,
            contador: null,
            openVehiculo: false,
        };
    }

    componentDidMount() {
        this.props.iniMotoscat();
    }

    getTitle() {
        const { marca, modelo, motor } = this.props;
        switch (this.props.view) {
            case MOTOSCAT_VIEW.MOTOS:
                return translate('tecdoc_vehiculo');
            case MOTOSCAT_VIEW.REFERENCIA:
                if (this.props.marca != null) {
                    return (
                        translate('articulos_moto') +
                        ' ' +
                        marca +
                        ' ' +
                        modelo +
                        ' ' +
                        motor
                    );
                }
                return translate('articulos');
            default:
                return '';
        }
    }

    getComponent() {
        const { view } = this.props;
        switch (view) {
            case MOTOSCAT_VIEW.MOTOS:
                return <MarcasMotos />;
            case MOTOSCAT_VIEW.REFERENCIA:
                return <Articulos />;
            default:
                return null;
        }
    }

    render() {
        const { open, closeMotoscat, isMobile } = this.props;
        return (
            <Drawer
                open={open}
                position='right'
                width={isMobile ? '100vw' : '75%'}
                onClose={closeMotoscat}
            >
                <ErrorBoundary
                    estado={this.props.estado}
                    fallback={FALLBACKS.DRAWER}
                    onClose={closeMotoscat}
                >
                    <div className='page-header'>
                        <div className='title'>
                            <i className='ms-Icon ms-Icon--Search icon-lg' />
                            <h4>{this.getTitle()}</h4>
                        </div>

                        <div className='actions'>
                            <CancelButton onClick={closeMotoscat} />
                        </div>
                    </div>
                    <div
                        className={`content motoscat-${
                            this.state.isGoingBack ? 'out' : 'in'
                        }`}
                    >
                        <TransitionGroup className='transition-wrapper'>
                            <CSSTransition
                                key={this.props.view}
                                timeout={600}
                                classNames={'fadeTranslate'}
                                mountOnEnter
                                unmountOnExit
                            >
                                <div
                                    className='transition'
                                    style={{ height: '100%' }}
                                >
                                    {this.getComponent()}
                                </div>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </ErrorBoundary>
            </Drawer>
        );
    }
}
export default withSizes(getBreakpoints)(
    connect(mapStateToProps, mapDispatchToProps)(Motoscat)
);
